export default __webpack_public_path__ + "static/media/left_layout.b6a59943.svg";